import React, { useState, useContext } from 'react';
import ExpandableRow from '../ExpandableRow';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Project, Link, StateContext } from '../../StateContext';
import { deleteLink } from '../../Services/APICalls/apicalls';
import { IContextData } from '../../../App';
import WeekView, { secondsToHours, totalHours } from './weekView';
import AddWeekOverview from './addWeekOverview';
import DeleteConfirmation from '../DeleteConfirmation';

interface IProps {
    link?: Link;
    project?: Project;
    filterTypeId?: number | null;
}

const LinkView = (props: IProps) => {
    const { loginData, setLoginData } = useContext<IContextData>(StateContext);
    const [open, setOpen] = useState(false);

    const handleClickOpen = (x) => { x.stopPropagation(); setOpen(true); };
    const handleClose = (x) => { x.stopPropagation(); setOpen(false); };
    const handleConfirmDelete = (x) => { x.stopPropagation(); deleteLink(props.link.id, setLoginData); setOpen(false); };

    const displayWeekData = props.filterTypeId !== undefined
        ? props.link.weekData.filter(w => props.filterTypeId === null ? w.projectTypeId == null : w.projectTypeId === props.filterTypeId)
        : props.link.weekData;

    return (
        <div className=''>
            <ExpandableRow
                Title={props.link?.mechanic?.name || props.project.name}
                total={totalHours(displayWeekData)}
                delButton={
                    <>
                        <IconButton aria-label='delete' size='small' onClick={handleClickOpen}>
                            <DeleteIcon />
                        </IconButton>
                        <DeleteConfirmation
                            handleDialogAbort={handleClose}
                            handleDialogConfirm={handleConfirmDelete}
                            dialogOpen={open}
                        />
                    </>
                }
                addWeek={<AddWeekOverview link={props.link} defaultTypeId={props.filterTypeId} />}
            >
                <WeekView link={props.link} project={props.project} filterTypeId={props.filterTypeId} />
            </ExpandableRow>
        </div>
    );
};

export default LinkView;
